<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  // import staticJson from '../static/json/static.json'
  import api from './api'
  export default {
    name: 'app',
    data () {
      return {
        section: 'Head',
        staticJson: {}
      }
    },
    mounted () {
      let _this = this
      api.getJsonStatico().then(resp => {
        console.debug(resp.data)
        _this.staticJson = resp.data
        _this.$store.commit('SET_JSON_STATIC', resp.data)
      })
    },
    methods: {
      logout () {
        this.$store.commit('SET_USER', null)
        this.$store.commit('SET_TOKEN', null)

        if (window.localStorage) {
          window.localStorage.setItem('user', null)
          window.localStorage.setItem('token', null)
        }

        this.$router.push('/login')
      }
    }
  }
</script>
<style>
#app {
  height: 100%;
  min-height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/App.vue